import { render, staticRenderFns } from "./AssetOrByteAmount.vue?vue&type=template&id=61695516&scoped=true&"
import script from "./AssetOrByteAmount.vue?vue&type=script&lang=js&"
export * from "./AssetOrByteAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61695516",
  null
  
)

export default component.exports